angular.module('clientDashboardApp').factory('browserService', function () {

  var appName = navigator.appName;
  var ua = window.navigator.userAgent;
  var isMSIE = false;

  if (appName == "Microsoft Internet Explorer") {
    var hasMsie = ua.indexOf("MSIE ") > -1;
    isMSIE = hasMsie;
  }
  else if (appName == "Netscape") {
    var hasTridentOrEdge = ua.search(/(Trident\/[0-9])|(Edge\/[0-9])/) > -1;
    isMSIE = hasTridentOrEdge;
  }
  else {
    isMSIE = false;
  }

  return {
    isMSIE: function () {
      return isMSIE;
    }
  }

});
